<template>
  <div>
    <div class="mt-2 space-y-5">
      <TabGroup
        vertical
        :selected-index="selected_tab_index"
        class="relative transition ease-in-out border rounded-lg focus:outline-none bg-light-box-background dark:bg-dark-box-background duration-side-menu-transition-duration"
        as="div"
        @change="selected_tab_index = $event">
        <TabList
          class="flex items-start relative border-b-[1px] dark:border-dark-divider-border rounded-tl-md shadow-sm rounded-tr-md focus:outline-none">
          <Tab v-for="element in tabs" :key="element" v-slot="{ selected }" as="template">
            <div
              :class="[selected ? '!text-blue text-[15px] font-normal' : 'font-normal']"
              class="sm:text-sm py-4 mx-[12px] transform translate-y-[3px] text-[#46545C] dark:text-common-grey hover:border-common-grey border-b-[2px] transition ease-in-out duration-300 rounded-sm relative focus:outline-none inline-flex ring-0 ring-offset-0 border-transparent cursor-pointer">
              {{ element }}
              <div
                :class="[
                  !selected ? 'scale-0' : '',
                  'absolute pointer-events-none transition transform ease-in-out duration-side-menu-transition-duration w-full  h-[2px] rounded-full  bg-light-brand-blue dark:bg-dark-brand-blue bottom-[-1px]'
                ]" />
            </div>
          </Tab>
        </TabList>
        <TabPanels class="shadow-lg">
          <TabPanel v-for="tab in tabs"
                    v-slot="{ selected }"
                    :key="tab"
                    static
                    class="outline-none">
            <div v-if="selected && selected_tab_index == 0" class="flex flex-col items-center w-full p-2 mt-2 space-y-5">
              <DatePicker v-model="selected_date" mode="date" />
            </div>

            <div v-else-if="selected && selected_tab_index == 1" class="flex flex-col mx-2 mt-3">
              <div class="flex items-center w-full gap-1 mb-1">
                <div class="w-full">
                  <TextInput
                    v-model="number"
                    name="due_date_days_offset"
                    :auto-focus="true"
                    :validate-on-input="true"
                    type="number"
                    :placeholder="$t('Number of Days')"
                    label="">
                    <template #postfix>
                      <div
                        class="absolute inset-y-0 right-0 flex items-center pr-3 mx-1 my-1 bg-white border-none outline-none pointer-events-none">
                        <span class="text-gray-500 dark:text-dark-body-text">{{ $t("Days") }}</span>
                      </div>
                    </template>
                  </TextInput>
                </div>
              </div>
              <div class="flex items-center w-full gap-1 mb-1">
                <div class="w-full pl-1">
                  <SelectInput
                    v-model="option"
                    :items="options"
                    :value="option"
                    name="due_date_relative_to"
                    label-attr="label"
                    value-attr="value"
                    :allow-null="false"
                    :is-box-background="true"
                    :disabled="false"
                    :show-label="false"
                    :classes="`w-full`"
                    label=""
                    placeholder="">
                    <template #prefix>
                      <div class="flex items-center justify-center h-full bg-white border-none outline-none pointer-events-none">
                        <span class="text-base text-gray-500 dark:text-dark-body-text">{{ $t("After") }}</span>
                      </div>
                    </template>
                  </SelectInput>
                </div>
              </div>
            </div>
          </TabPanel>
          <div class="flex justify-end gap-2 p-2 pb-2" :class="[selected_tab_index == 1 ? 'mt-16' : '']">
            <button type="button" class="w-fit cancel-btn py-2.5 -ml-1" @click="$emit('cancel')">
              <span>{{ $t("Cancel") }}</span>
            </button>
            <button
              v-if="selected_tab_index == 1"
              :disabled="!number"
              class="w-fit primary-btn disabled:opacity-50"
              @click.stop="calcDate()">
              {{ $t("Apply") }}
            </button>
          </div>
        </TabPanels>
      </TabGroup>
    </div>
  </div>
</template>

<script>
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/vue"
import { DatePicker } from "v-calendar"
import TextInput from "@/components/shared/TextInput.vue"
import SelectInput from "@/components/shared/SelectInput.vue"
export default {
  components: {
    DatePicker,
    TextInput,
    SelectInput,
    Tab,
    TabGroup,
    TabList,
    TabPanel,
    TabPanels
  },
  props: {
    relativeDate: {
      type: Object,
      required: true
    }
  },
  emits: ["cancel", "done", "relativeDateChanged"],
  data() {
    return {
      selected_date: null,
      selected_tab_index: 0,
      tabs: ["Date", "Timeframe"],
      number: 1,
      options: [
        { label: this.$t("Creation Date"), value: "datetime_created" },
        { label: this.$t("Start Date"), value: "start_date" },
        { label: this.$t("In progress Date"), value: "in_progress_date" }
      ],
      option: "datetime_created",
      relative_date_clone: null
    }
  },
  watch: {
    selected_date() {
      if (this.selected_date) {
        this.$emit("relativeDateChanged", null)
        this.$emit("done", this.selected_date)
      }
    }
  },
  created() {
    if (this.relativeDate?.due_date_relative_to) {
      this.option = this.relativeDate.due_date_relative_to
      this.number = this.relativeDate.due_date_days_offset
    }
    if (this.relativeDate?.due_date_relative_to) {
      this.selected_tab_index = 1
    }
    this.relative_date_clone = Object.assign({}, this.relativeDate)
  },

  methods: {
    calcDate() {
      let relative_date = {
        due_date_relative_to: this.option,
        due_date_days_offset: this.number
      }
      this.$emit("relativeDateChanged", relative_date)
    }
  }
}
</script>
